<template>
  <a-modal
    :visible="visible"
    :title="title"
    @ok="ok"
    @cancel="cancel"
    width="40%"
  >
    <a-form
      ref="formRef"
      :model="formData"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <form-input
        label="词条KEY"
        name="keyName"
        :disabled="formData.id"
        v-model:value="formData.keyName"
      ></form-input>
      <form-select
        label="归属系统"
        name="systemId"
        :disabled="formData.id"
        v-model:value="formData.systemId"
      >
        <a-select-option
          :value="+item.id"
          v-for="(item, key) in systems"
          :key="key"
        >
          {{ item.code }}
        </a-select-option>
      </form-select>
      <template v-for="(item, key, index) of langField" :key="index">
        <form-input
          :label="item"
          :name="key"
          v-model:value="formData[key]"
        ></form-input>
      </template>
    </a-form>
  </a-modal>
</template>
<script>
import { message } from 'ant-design-vue'
import { inject, toRefs, reactive, ref } from 'vue'
import { language_key_operate_post } from 'server/modules/351.js'
export default {
  setup() {
    const state = inject('state')
    const formRef = ref()
    const alertState = reactive({
      cancel() {
        const { setAttrs } = state
        setAttrs('visible', false)
        state.setEmpty()
      },
      ok: async () => {
        formRef.value
          .validate()
          .then(() => {
            alertState.add()
          })
          .catch(error => {
            console.log('error', error)
          })
      },
      // 新增地址
      add: async () => {
        const { success, retInfo, data } = await language_key_operate_post(
          state.formData
        ).catch(() => {})
        if (success) {
          alertState.cancel()
          state.changePage(1)
          message.info(data)
        } else {
          message.error(retInfo)
        }
      }
    })
    const rules = {
      systemId: [
        {
          required: true,
          message: '必填',
          trigger: 'blur',
          type: 'number'
        }
      ],
      keyName: [{ required: true, message: '必填', trigger: 'blur' }]
    }

    return {
      formRef,
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      rules,
      ...toRefs(alertState),
      ...toRefs(state)
    }
  }
}
</script>
